import React__default from 'react';
import BottomSheet from './BottomSheet.js';
import { L as Label, a as LabelTypography, b as LabelColors } from '../chunks/bundle-CjJk57u5.js';
import { u as useLocalization } from '../chunks/bundle-d1cOX5nv.js';
import 'react-dom';
import '../chunks/bundle-DRpjMk0B.js';
import '../chunks/bundle-CxLxJCBu.js';
import '../chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import '../utils/message/getOutgoingMessageState.js';
import '../chunks/bundle-DiK8ifY3.js';
import '../chunks/bundle-C-nZYnmy.js';
import '../chunks/bundle-DP3z2QNm.js';
import '../chunks/bundle-kFa80LJe.js';
import '../chunks/bundle-Ci-RNuvu.js';
import './IconButton.js';
import './Button.js';
import './Icon.js';
import '@sendbird/uikit-tools';
import '../withSendbird.js';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import '../chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import '../chunks/bundle-DdJ9pMWn.js';
import '../useSendbirdStateContext.js';
import '../chunks/bundle-BzR1dD25.js';
import './SortByRow.js';
import '../chunks/bundle-DS1EhNtb.js';

function MobileFeedbackMenu(props) {
    var hideMenu = props.hideMenu, onEditFeedback = props.onEditFeedback, onRemoveFeedback = props.onRemoveFeedback;
    var stringSet = useLocalization().stringSet;
    return (React__default.createElement(BottomSheet, { onBackdropClick: hideMenu },
        React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-options-menu' },
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onEditFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ONBACKGROUND_1 }, stringSet.EDIT_COMMENT)),
            React__default.createElement("div", { className: 'sendbird-message__bottomsheet--feedback-option', onClick: function () {
                    hideMenu();
                    onRemoveFeedback();
                } },
                React__default.createElement(Label, { type: LabelTypography.BODY_1, color: LabelColors.ERROR }, stringSet.REMOVE_FEEDBACK)))));
}

export { MobileFeedbackMenu as default };
//# sourceMappingURL=MobileFeedbackMenu.js.map
